import React from 'react'
import { Modal, ModalKind as UiModalKind, Button, ButtonKind, TextInput, InputLabel } from '@aposphaere/ui-components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useRequestPasswordResetMutation } from '../../hooks/graphql/password'
import { toast } from '@aposphaere/ui-components'

type FormValues = {
  email: string
}

const validationSchema = Yup.object({
  email: Yup.string().email('Ungültige E-Mail').required('Pflichtfeld'),
})

const PasswortForgotModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { mutateAsync, isLoading } = useRequestPasswordResetMutation()
  const { handleSubmit, handleChange, values, errors, touched } = useFormik<FormValues>({
    initialValues: { email: '' },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const res = await mutateAsync({ email: values.email })

        if (!res?.requestPasswordReset) {
          toast.show({
            headline: 'Wir konnten kein Konto mit dieser E-Mail-Adresse finden',
            type: 'error',
          })
          return
        }

        toast.show({
          headline: 'Wenn ein Konto mit dieser E-Mail-Adresse existiert, wurde eine E-Mail zum Zurücksetzen des Passworts versendet.',
          type: 'success',
        })

        onClose()
      } catch (error: any) {
        toast.show({
          headline: error?.message || 'Fehler beim Zurücksetzen des Passworts',
          type: 'error',
        })
      }
    }
  })

  return (
    <Modal
      kind={UiModalKind.sm}
      title="Passwort vergessen"
      onClose={onClose}
      onBack={() => null}
    >
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 p-4 w-full max-w-md mx-auto"
      >
        <div>
          <InputLabel htmlFor="email">E-Mail</InputLabel>
          <TextInput
            id="email"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
          />

          {errors.email && touched.email && (
            <div className="text-red-500 text-sm mt-1">{errors.email}</div>
          )}

        </div>

        <div className="flex justify-end mt-2">
          <Button type="submit" kind={ButtonKind.primary} disabled={isLoading}>
            {isLoading ? 'Wird gesendet...' : 'Passwort zurücksetzen'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default PasswortForgotModal